import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { publishStrategyToEva, updateStrategyInEva } from '../../../../api';
import { ApiDataResponse } from '../../../../api/types/response';

export const useEva = (strategyId: string) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = (result: Pick<ApiDataResponse<unknown>, 'success' | 'errorMessage'>) => {
    if (!result.success) {
      enqueueSnackbar(result.errorMessage || 'Ошибка', { variant: 'error' });
      return;
    }
    enqueueSnackbar('Успешно');
  };

  const onError = (e: unknown) => {
    enqueueSnackbar(String(e), { variant: 'error' });
  };

  const publishMutation = useMutation({ mutationFn: () => publishStrategyToEva(strategyId), onSuccess, onError });
  const updateMutation = useMutation({ mutationFn: () => updateStrategyInEva(strategyId), onSuccess, onError });

  return {
    loading: publishMutation.isPending || updateMutation.isPending,
    onPublishToEva: () => publishMutation.mutate(),
    onUpdateInEva: () => updateMutation.mutate(),
  };
};
